import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { stockEntry } = stateEnum

const initialState = {
  detailParams: {},
  isNewEntry: false,
  detailLotNo:[],
  stockLotNo:  {filters:{},lotnos:[],isInward:0},
  stockParamUploadDetail:{},
  isUploadParamNewEntry: false,
}


const stockEntrySlice = createSlice({
  name: stockEntry,
  initialState,
  reducers: {

    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetailParams: (state) => {
      state.detailParams = {}
      state.isNewEntry = true

    },
    setDetailLotno: (state, action) => {
      console.log(action.payload)
      state.detailLotNo = action.payload
    },
     setStockLotno: (state, action) => {
      state.stockLotNo = action.payload
    },
    resetStockLotno: (state) => {
      state.stockLotNo =  {filters:{},lotnos:[],isInward:0}
    },
     setStockParamUploadDetail: (state, action) => {
      state.stockParamUploadDetail = action.payload
    },
     setUploadParamNewEntryMode: (state, action) => {
      state.isUploadParamNewEntry = action.payload
    },
  },

})

export const { setDetailParams, resetDetailParams,resetStockLotno, setNewEntryMode, setUploadParamNewEntryMode,setDetailLotno,setStockLotno,setStockParamUploadDetail} = stockEntrySlice.actions
export default stockEntrySlice.reducer
